import {
  InitiateLyraReferralRequest,
  LyraPartnerService
} from "@9amhealth/openapi";
import { Cubit } from "blac-next";
import reportErrorSentry from "src/lib/reportErrorSentry";

/**
 * Cubit for handling Lyra specific operations
 */
export class LyraConsentCubit extends Cubit<{ isLoading: boolean }> {
  constructor() {
    super({ isLoading: false });
  }

  /**
   * Requests a connecting url to Lyra (their own system), with or without consent.
   *
   * - consent granted: the response url should contain a token, not to be cached
   * - consent denied: the response url should be a generic url to the Lyra page
   * @param args
   */
  public readonly getLyraUrlWithConsent = async (
    args: InitiateLyraReferralRequest
  ) => {
    try {
      this.emit({
        ...this.state,
        isLoading: true
      });
      const {
        data: { redirectUrl }
      } = await LyraPartnerService.initiateLyraReferral(args);
      return { redirectUrl };
    } catch (error) {
      reportErrorSentry(error);
      throw error;
    } finally {
      this.emit({
        ...this.state,
        isLoading: false
      });
    }
  };
}
